// extracted by mini-css-extract-plugin
export default {"invalidDataError":"SignUp_invalidDataError__+TP08"};